export const CONNECT_COLLECTION = 'CONNECT_COLLECTION';
